// HERBLABS i18n — UI copy in 5 languages targeting core export markets.
// Product/catalog item names (botanical trade names) intentionally stay in English.

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN", dir: "ltr" },
  { code: "es", label: "Español", short: "ES", dir: "ltr" },
  { code: "fr", label: "Français", short: "FR", dir: "ltr" },
  { code: "de", label: "Deutsch", short: "DE", dir: "ltr" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
];

export const translations = {
  en: {
    nav: { story: "Story", divisions: "Divisions", quality: "Quality", contact: "Contact", quote: "Request a Quote" },
    hero: {
      badge: "Est. 2026 · Haryana, India",
      l1: "India's Natural Best —",
      l2: "Delivered to",
      l3: "the World.",
      subtitle: "HERBLABS Private Limited exports premium herbal powders, botanical extracts and agri-commodities — sourced directly from certified Indian manufacturers, backed by verified lab reports and full farm-to-shipment traceability.",
      explore: "Explore Divisions",
      contact: "Request Sourcing Quote",
      scroll: "Scroll to discover",
      imgBadge: "Lab-Tested · Traceable",
    },
    manifesto: {
      overline: "The Herblabs Standard",
      c1t: "Pure Origins",
      c1b: "Operating from Gohana, Haryana — one of India's key agricultural and processing hubs — we source directly from trusted, certified manufacturers, cutting out middleman markups and bridging India's rich natural produce with the world's health, wellness and food industries.",
      c2t: "Verified Quality",
      c2b: "Every product we export is backed by verified laboratory test reports, phytosanitary certification and full traceability from farm to shipment — ensuring our buyers receive exactly what they order, every single time.",
      c3t: "Global Reach",
      c3b: "We serve nutraceutical brands, health-food and functional-food manufacturers, Ayurvedic wellness brands, importers and private-label companies across the USA, Europe, the Middle East and beyond.",
      c4t: "A Fair Advantage",
      c4b: "Single-source convenience, compliance-ready documentation, flexible MOQs and transparent, secure transactions — with access to both organic and conventional options and consistent year-round supply.",
    },
    divisions: {
      overline: "Our Products at a Glance",
      h1: "Three divisions,",
      h2: "one source of truth.",
      label: "Division",
      enquire: "Enquire About This Division",
      botanical_name: "Botanical Ingredients",
      botanical_tag: "Herbal powders, extracts, functional ingredients & pure essential oils.",
      agri_name: "Agri Commodities",
      agri_tag: "Spices, grains, pulses, nuts, natural sweeteners & cold-pressed oils.",
      "value-added_name": "Value-Added Products",
      "value-added_tag": "Finished nutraceutical formulations, herbal teas & premium coffee.",
    },
    specs: {
      overline: "Quality & Compliance",
      h1: "Technical specifications,",
      h2: "documented every time.",
      param: "Parameter",
      method: "Method",
      typical: "Typical",
      footnote: "* Specifications are indicative. Product-specific data sheets and standardised actives are shared on request.",
    },
    contact: {
      overline: "Let's Talk Sourcing",
      h1: "From India's fields",
      h2: "to your formula.",
      send: "Send an Inquiry",
      callback: "Request a Callback",
      name: "Name", email: "Email", company: "Company", country: "Country",
      product: "Product of Interest", message: "Message", phone: "Phone", time: "Preferred Time",
      ph_name: "Your full name", ph_email: "you@company.com", ph_company: "Company name",
      ph_country: "e.g. United States", ph_product: "Select a division",
      ph_message: "Tell us about your requirement, target quantity & MOQ...",
      ph_phone: "+1 555 000 0000", ph_time: "e.g. Weekdays, 10am–2pm IST",
      submit_contact: "Submit Inquiry", submit_callback: "Request Callback",
      worldwide: "Export inquiries welcome worldwide",
      ok_contact: "Inquiry received. Our team will be in touch shortly.",
      ok_callback: "Callback requested. We'll ring you back soon.",
      required: "Please fill in all required fields.",
      ratelimit: "Too many requests. Please try again in a few minutes.",
      error: "Something went wrong. Please try again.",
      opt_general: "General / Multiple",
    },
    footer: { rights: "HERBLABS Private Limited · Founded 2026 · Haryana, India", tagline: "India's Natural Best — Delivered to the World" },
    intro: "India's Natural Best",
  },

  es: {
    nav: { story: "Historia", divisions: "Divisiones", quality: "Calidad", contact: "Contacto", quote: "Solicitar Cotización" },
    hero: {
      badge: "Fundada en 2026 · Haryana, India",
      l1: "Lo Mejor Natural de India —",
      l2: "Entregado al",
      l3: "Mundo.",
      subtitle: "HERBLABS Private Limited exporta polvos herbales premium, extractos botánicos y productos agrícolas — obtenidos directamente de fabricantes indios certificados, respaldados por informes de laboratorio verificados y trazabilidad completa del campo al envío.",
      explore: "Explorar Divisiones",
      contact: "Solicitar Cotización",
      scroll: "Desplácese para descubrir",
      imgBadge: "Analizado · Trazable",
    },
    manifesto: {
      overline: "El Estándar Herblabs",
      c1t: "Orígenes Puros",
      c1b: "Operando desde Gohana, Haryana — uno de los principales centros agrícolas de India — nos abastecemos directamente de fabricantes certificados de confianza, eliminando sobreprecios de intermediarios y conectando la rica producción natural de India con las industrias globales de salud, bienestar y alimentación.",
      c2t: "Calidad Verificada",
      c2b: "Cada producto que exportamos está respaldado por informes de laboratorio verificados, certificación fitosanitaria y trazabilidad completa del campo al envío — asegurando que nuestros compradores reciban exactamente lo que piden, siempre.",
      c3t: "Alcance Global",
      c3b: "Atendemos a marcas nutracéuticas, fabricantes de alimentos saludables y funcionales, marcas de bienestar ayurvédico, importadores y empresas de marca blanca en EE. UU., Europa, Oriente Medio y más allá.",
      c4t: "Una Ventaja Justa",
      c4b: "Conveniencia de un solo proveedor, documentación lista para cumplimiento, MOQ flexibles y transacciones transparentes y seguras — con acceso a opciones orgánicas y convencionales y suministro constante todo el año.",
    },
    divisions: {
      overline: "Nuestros Productos en Resumen",
      h1: "Tres divisiones,",
      h2: "una sola fuente de confianza.",
      label: "División",
      enquire: "Consultar sobre esta División",
      botanical_name: "Ingredientes Botánicos",
      botanical_tag: "Polvos herbales, extractos, ingredientes funcionales y aceites esenciales puros.",
      agri_name: "Productos Agrícolas",
      agri_tag: "Especias, granos, legumbres, frutos secos, edulcorantes naturales y aceites prensados en frío.",
      "value-added_name": "Productos de Valor Añadido",
      "value-added_tag": "Formulaciones nutracéuticas terminadas, tés herbales y café premium.",
    },
    specs: {
      overline: "Calidad y Cumplimiento",
      h1: "Especificaciones técnicas,",
      h2: "documentadas siempre.",
      param: "Parámetro",
      method: "Método",
      typical: "Típico",
      footnote: "* Las especificaciones son indicativas. Las fichas técnicas específicas y los activos estandarizados se comparten a solicitud.",
    },
    contact: {
      overline: "Hablemos de Abastecimiento",
      h1: "De los campos de India",
      h2: "a su fórmula.",
      send: "Enviar una Consulta",
      callback: "Solicitar una Llamada",
      name: "Nombre", email: "Correo", company: "Empresa", country: "País",
      product: "Producto de Interés", message: "Mensaje", phone: "Teléfono", time: "Horario Preferido",
      ph_name: "Su nombre completo", ph_email: "usted@empresa.com", ph_company: "Nombre de la empresa",
      ph_country: "ej. Estados Unidos", ph_product: "Seleccione una división",
      ph_message: "Cuéntenos sobre su requerimiento, cantidad objetivo y MOQ...",
      ph_phone: "+1 555 000 0000", ph_time: "ej. Días laborables, 10–14h IST",
      submit_contact: "Enviar Consulta", submit_callback: "Solicitar Llamada",
      worldwide: "Consultas de exportación bienvenidas en todo el mundo",
      ok_contact: "Consulta recibida. Nuestro equipo se pondrá en contacto pronto.",
      ok_callback: "Llamada solicitada. Le devolveremos la llamada pronto.",
      required: "Por favor complete todos los campos obligatorios.",
      ratelimit: "Demasiadas solicitudes. Inténtelo de nuevo en unos minutos.",
      error: "Algo salió mal. Por favor, inténtelo de nuevo.",
      opt_general: "General / Múltiple",
    },
    footer: { rights: "HERBLABS Private Limited · Fundada en 2026 · Haryana, India", tagline: "Lo Mejor Natural de India — Entregado al Mundo" },
    intro: "Lo Mejor Natural de India",
  },

  fr: {
    nav: { story: "Histoire", divisions: "Divisions", quality: "Qualité", contact: "Contact", quote: "Demander un Devis" },
    hero: {
      badge: "Fondée en 2026 · Haryana, Inde",
      l1: "Le Meilleur Naturel de l'Inde —",
      l2: "Livré au",
      l3: "Monde.",
      subtitle: "HERBLABS Private Limited exporte des poudres à base de plantes premium, des extraits botaniques et des matières premières agricoles — approvisionnés directement auprès de fabricants indiens certifiés, appuyés par des rapports de laboratoire vérifiés et une traçabilité complète du champ à l'expédition.",
      explore: "Explorer les Divisions",
      contact: "Demander un Devis",
      scroll: "Faites défiler pour découvrir",
      imgBadge: "Testé en Labo · Traçable",
    },
    manifesto: {
      overline: "La Norme Herblabs",
      c1t: "Origines Pures",
      c1b: "Basés à Gohana, Haryana — l'un des principaux pôles agricoles de l'Inde — nous nous approvisionnons directement auprès de fabricants certifiés de confiance, éliminant les marges des intermédiaires et reliant la riche production naturelle de l'Inde aux industries mondiales de la santé, du bien-être et de l'alimentation.",
      c2t: "Qualité Vérifiée",
      c2b: "Chaque produit que nous exportons est appuyé par des rapports de laboratoire vérifiés, une certification phytosanitaire et une traçabilité complète du champ à l'expédition — garantissant à nos acheteurs de recevoir exactement ce qu'ils commandent, à chaque fois.",
      c3t: "Portée Mondiale",
      c3b: "Nous servons des marques nutraceutiques, des fabricants d'aliments santé et fonctionnels, des marques de bien-être ayurvédique, des importateurs et des sociétés de marque de distributeur aux États-Unis, en Europe, au Moyen-Orient et au-delà.",
      c4t: "Un Avantage Équitable",
      c4b: "Commodité d'une source unique, documentation prête pour la conformité, MOQ flexibles et transactions transparentes et sécurisées — avec accès aux options biologiques et conventionnelles et un approvisionnement constant toute l'année.",
    },
    divisions: {
      overline: "Nos Produits en un Coup d'œil",
      h1: "Trois divisions,",
      h2: "une seule source de vérité.",
      label: "Division",
      enquire: "Se Renseigner sur cette Division",
      botanical_name: "Ingrédients Botaniques",
      botanical_tag: "Poudres à base de plantes, extraits, ingrédients fonctionnels et huiles essentielles pures.",
      agri_name: "Matières Premières Agricoles",
      agri_tag: "Épices, céréales, légumineuses, noix, édulcorants naturels et huiles pressées à froid.",
      "value-added_name": "Produits à Valeur Ajoutée",
      "value-added_tag": "Formulations nutraceutiques finies, tisanes et café premium.",
    },
    specs: {
      overline: "Qualité et Conformité",
      h1: "Spécifications techniques,",
      h2: "documentées à chaque fois.",
      param: "Paramètre",
      method: "Méthode",
      typical: "Typique",
      footnote: "* Les spécifications sont indicatives. Les fiches techniques spécifiques et les actifs standardisés sont partagés sur demande.",
    },
    contact: {
      overline: "Parlons Approvisionnement",
      h1: "Des champs de l'Inde",
      h2: "à votre formule.",
      send: "Envoyer une Demande",
      callback: "Demander un Rappel",
      name: "Nom", email: "E-mail", company: "Entreprise", country: "Pays",
      product: "Produit d'Intérêt", message: "Message", phone: "Téléphone", time: "Horaire Préféré",
      ph_name: "Votre nom complet", ph_email: "vous@entreprise.com", ph_company: "Nom de l'entreprise",
      ph_country: "ex. États-Unis", ph_product: "Sélectionnez une division",
      ph_message: "Parlez-nous de votre besoin, quantité cible et MOQ...",
      ph_phone: "+1 555 000 0000", ph_time: "ex. En semaine, 10h–14h IST",
      submit_contact: "Envoyer la Demande", submit_callback: "Demander un Rappel",
      worldwide: "Demandes d'exportation bienvenues dans le monde entier",
      ok_contact: "Demande reçue. Notre équipe vous contactera sous peu.",
      ok_callback: "Rappel demandé. Nous vous rappellerons bientôt.",
      required: "Veuillez remplir tous les champs obligatoires.",
      ratelimit: "Trop de requêtes. Veuillez réessayer dans quelques minutes.",
      error: "Une erreur s'est produite. Veuillez réessayer.",
      opt_general: "Général / Multiple",
    },
    footer: { rights: "HERBLABS Private Limited · Fondée en 2026 · Haryana, Inde", tagline: "Le Meilleur Naturel de l'Inde — Livré au Monde" },
    intro: "Le Meilleur Naturel de l'Inde",
  },

  de: {
    nav: { story: "Geschichte", divisions: "Bereiche", quality: "Qualität", contact: "Kontakt", quote: "Angebot Anfordern" },
    hero: {
      badge: "Gegründet 2026 · Haryana, Indien",
      l1: "Indiens Natürlich Bestes —",
      l2: "Geliefert in die",
      l3: "Welt.",
      subtitle: "HERBLABS Private Limited exportiert hochwertige Kräuterpulver, botanische Extrakte und Agrarrohstoffe — direkt von zertifizierten indischen Herstellern bezogen, gestützt durch geprüfte Laborberichte und vollständige Rückverfolgbarkeit vom Feld bis zum Versand.",
      explore: "Bereiche Entdecken",
      contact: "Angebot Anfordern",
      scroll: "Zum Entdecken scrollen",
      imgBadge: "Laborgeprüft · Rückverfolgbar",
    },
    manifesto: {
      overline: "Der Herblabs-Standard",
      c1t: "Reine Ursprünge",
      c1b: "Von Gohana, Haryana aus — einem der wichtigsten Agrar- und Verarbeitungszentren Indiens — beziehen wir direkt von vertrauenswürdigen, zertifizierten Herstellern, sparen Zwischenhändleraufschläge und verbinden Indiens reiche Naturprodukte mit den globalen Gesundheits-, Wellness- und Lebensmittelindustrien.",
      c2t: "Geprüfte Qualität",
      c2b: "Jedes exportierte Produkt wird durch geprüfte Laborberichte, phytosanitäre Zertifizierung und vollständige Rückverfolgbarkeit vom Feld bis zum Versand gestützt — damit unsere Käufer jedes Mal genau das erhalten, was sie bestellen.",
      c3t: "Globale Reichweite",
      c3b: "Wir beliefern Nutrazeutika-Marken, Hersteller von Gesundheits- und funktionellen Lebensmitteln, ayurvedische Wellness-Marken, Importeure und Eigenmarken-Unternehmen in den USA, Europa, dem Nahen Osten und darüber hinaus.",
      c4t: "Ein Fairer Vorteil",
      c4b: "Komfort aus einer Hand, konforme Dokumentation, flexible MOQs und transparente, sichere Transaktionen — mit Zugang zu Bio- und konventionellen Optionen und ganzjährig konstanter Versorgung.",
    },
    divisions: {
      overline: "Unsere Produkte im Überblick",
      h1: "Drei Bereiche,",
      h2: "eine verlässliche Quelle.",
      label: "Bereich",
      enquire: "Zu diesem Bereich Anfragen",
      botanical_name: "Botanische Zutaten",
      botanical_tag: "Kräuterpulver, Extrakte, funktionelle Zutaten & reine ätherische Öle.",
      agri_name: "Agrarrohstoffe",
      agri_tag: "Gewürze, Getreide, Hülsenfrüchte, Nussfrüchte, natürliche Süßstoffe & kaltgepresste Öle.",
      "value-added_name": "Veredelte Produkte",
      "value-added_tag": "Fertige nutrazeutische Formulierungen, Kräutertees & Premium-Kaffee.",
    },
    specs: {
      overline: "Qualität & Konformität",
      h1: "Technische Spezifikationen,",
      h2: "jedes Mal dokumentiert.",
      param: "Parameter",
      method: "Methode",
      typical: "Typisch",
      footnote: "* Spezifikationen sind Richtwerte. Produktspezifische Datenblätter und standardisierte Wirkstoffe werden auf Anfrage bereitgestellt.",
    },
    contact: {
      overline: "Sprechen Wir über Beschaffung",
      h1: "Von Indiens Feldern",
      h2: "zu Ihrer Formel.",
      send: "Anfrage Senden",
      callback: "Rückruf Anfordern",
      name: "Name", email: "E-Mail", company: "Firma", country: "Land",
      product: "Produktinteresse", message: "Nachricht", phone: "Telefon", time: "Bevorzugte Zeit",
      ph_name: "Ihr vollständiger Name", ph_email: "sie@firma.com", ph_company: "Firmenname",
      ph_country: "z. B. Vereinigte Staaten", ph_product: "Bereich auswählen",
      ph_message: "Erzählen Sie uns von Ihrem Bedarf, Zielmenge & MOQ...",
      ph_phone: "+1 555 000 0000", ph_time: "z. B. Werktags, 10–14 Uhr IST",
      submit_contact: "Anfrage Absenden", submit_callback: "Rückruf Anfordern",
      worldwide: "Exportanfragen weltweit willkommen",
      ok_contact: "Anfrage erhalten. Unser Team meldet sich in Kürze.",
      ok_callback: "Rückruf angefordert. Wir rufen Sie bald zurück.",
      required: "Bitte füllen Sie alle Pflichtfelder aus.",
      ratelimit: "Zu viele Anfragen. Bitte versuchen Sie es in einigen Minuten erneut.",
      error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      opt_general: "Allgemein / Mehrere",
    },
    footer: { rights: "HERBLABS Private Limited · Gegründet 2026 · Haryana, Indien", tagline: "Indiens Natürlich Bestes — Geliefert in die Welt" },
    intro: "Indiens Natürlich Bestes",
  },

  ar: {
    nav: { story: "قصتنا", divisions: "الأقسام", quality: "الجودة", contact: "اتصل بنا", quote: "اطلب عرض سعر" },
    hero: {
      badge: "تأسست عام 2026 · هاريانا، الهند",
      l1: "أفضل ما في الطبيعة الهندية —",
      l2: "نُوصِّله إلى",
      l3: "العالم.",
      subtitle: "تصدّر شركة HERBLABS المحدودة مساحيق الأعشاب الممتازة والمستخلصات النباتية والسلع الزراعية — مصدرها مباشرةً من مصنّعين هنود معتمدين، مدعومة بتقارير مخبرية موثّقة وتتبّع كامل من المزرعة حتى الشحن.",
      explore: "استكشف الأقسام",
      contact: "اطلب عرض سعر",
      scroll: "مرّر للاكتشاف",
      imgBadge: "مُختبَر · قابل للتتبّع",
    },
    manifesto: {
      overline: "معيار Herblabs",
      c1t: "أصول نقية",
      c1b: "من مقرّنا في غوهانا، هاريانا — أحد أهم المراكز الزراعية في الهند — نحصل على منتجاتنا مباشرةً من مصنّعين معتمدين موثوقين، مع إلغاء هوامش الوسطاء وربط منتجات الهند الطبيعية الغنية بصناعات الصحة والعافية والأغذية العالمية.",
      c2t: "جودة موثّقة",
      c2b: "كل منتج نصدّره مدعوم بتقارير مخبرية موثّقة وشهادة الصحة النباتية وتتبّع كامل من المزرعة إلى الشحن — لنضمن أن يتسلّم مشترونا ما طلبوه تمامًا في كل مرة.",
      c3t: "انتشار عالمي",
      c3b: "نخدم علامات المكمّلات الغذائية، ومصنّعي الأغذية الصحية والوظيفية، وعلامات العافية الأيورفيدية، والمستوردين وشركات العلامات الخاصة في الولايات المتحدة وأوروبا والشرق الأوسط وما بعدها.",
      c4t: "ميزة عادلة",
      c4b: "راحة المصدر الواحد، ووثائق جاهزة للامتثال، وحدود طلب مرنة، ومعاملات شفافة وآمنة — مع خيارات عضوية وتقليدية وإمداد ثابت على مدار العام.",
    },
    divisions: {
      overline: "منتجاتنا في لمحة",
      h1: "ثلاثة أقسام،",
      h2: "مصدر واحد موثوق.",
      label: "القسم",
      enquire: "استفسر عن هذا القسم",
      botanical_name: "المكوّنات النباتية",
      botanical_tag: "مساحيق أعشاب، ومستخلصات، ومكوّنات وظيفية، وزيوت عطرية نقية.",
      agri_name: "السلع الزراعية",
      agri_tag: "توابل، وحبوب، وبقوليات، ومكسّرات، ومحلّيات طبيعية، وزيوت معصورة على البارد.",
      "value-added_name": "المنتجات ذات القيمة المضافة",
      "value-added_tag": "تركيبات مكمّلات جاهزة، وشاي أعشاب، وقهوة ممتازة.",
    },
    specs: {
      overline: "الجودة والامتثال",
      h1: "المواصفات الفنية،",
      h2: "موثّقة في كل مرة.",
      param: "المعيار",
      method: "الطريقة",
      typical: "النموذجي",
      footnote: "* المواصفات إرشادية. تُشارك أوراق البيانات الخاصة بكل منتج والمكوّنات الفعّالة المعيارية عند الطلب.",
    },
    contact: {
      overline: "لنتحدّث عن التوريد",
      h1: "من حقول الهند",
      h2: "إلى تركيبتك.",
      send: "إرسال استفسار",
      callback: "اطلب معاودة الاتصال",
      name: "الاسم", email: "البريد الإلكتروني", company: "الشركة", country: "الدولة",
      product: "المنتج المهتم به", message: "الرسالة", phone: "الهاتف", time: "الوقت المفضّل",
      ph_name: "اسمك الكامل", ph_email: "you@company.com", ph_company: "اسم الشركة",
      ph_country: "مثال: الولايات المتحدة", ph_product: "اختر قسمًا",
      ph_message: "أخبرنا عن متطلباتك والكمية المطلوبة والحد الأدنى للطلب...",
      ph_phone: "+1 555 000 0000", ph_time: "مثال: أيام العمل، 10ص–2م بتوقيت الهند",
      submit_contact: "إرسال الاستفسار", submit_callback: "اطلب معاودة الاتصال",
      worldwide: "نرحّب باستفسارات التصدير من جميع أنحاء العالم",
      ok_contact: "تم استلام الاستفسار. سيتواصل معك فريقنا قريبًا.",
      ok_callback: "تم طلب معاودة الاتصال. سنعاود الاتصال بك قريبًا.",
      required: "يرجى ملء جميع الحقول المطلوبة.",
      ratelimit: "طلبات كثيرة جدًا. يرجى المحاولة مرة أخرى بعد بضع دقائق.",
      error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      opt_general: "عام / متعدد",
    },
    footer: { rights: "HERBLABS Private Limited · تأسست 2026 · هاريانا، الهند", tagline: "أفضل ما في الطبيعة الهندية — نُوصِّله إلى العالم" },
    intro: "أفضل ما في الطبيعة الهندية",
  },
};
